import React from "react";
export const GameIconAndLabel = ({ imgSrc, label }) => {
    return (React.createElement("div", { className: "game-icon-and-label" },
        React.createElement("img", { className: "game-label-img", "data-testid": "game-label-img", src: imgSrc, alt: "Game Icon" }),
        React.createElement("h2", { className: "game-label-text", "data-testid": "game-label-text" }, label)));
};
//# sourceMappingURL=GameIconAndLabel.js.map